@let view = data();

@switch (view.level) {
  @case ("H1") {
    <h1>{{ view.text }}</h1>
  }
  @case ("H2") {
    <h2>{{ view.text }}</h2>
  }
  @case ("H3") {
    <h3>{{ view.text }}</h3>
  }
}